/**
 * @author Fernando Ruano
 * @file index.jsx
 * @description FormGenerator Component.
 */

// Dependencies
import React from 'react';
import { Form, Row } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Components
import FormItem from '@nephro/components/FormItem';

const FormGenerator = ({
  items,
  validateMessages,
  bottomOptions,
  bottomPosition,
  onFinish,
  onFinishFailed,
  initialValues,
  optionsFirst,
  requiredMark,
  formParam
}) => {
  const [form] = Form.useForm();
  const { t: translate } = useTranslation();
  /* eslint-disable no-template-curly-in-string */
  const validationMessages = {
    required: translate('commons.required'),
    ...validateMessages,
    types: {
      ...validateMessages.types,
      email: translate('commons.emailType')
    }
  };
  /* eslint-enable no-template-curly-in-string */
  const layout = {
    layout: 'vertical'
  };

  React.useEffect(() => {
    if (formParam) {
      formParam.setFieldsValue({
        ...initialValues
      });
    } else {
      form.setFieldsValue({
        ...initialValues
      });
    }
  }, []);

  return (
    <Form
      form={formParam || form}
      {...layout}
      requiredMark={requiredMark}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      validateMessages={validationMessages}>
      <div
        className={`flex  ${
          optionsFirst ? 'iphone5:flex-col-reverse md:flex-col' : 'flex-col'
        }`}>
        <Row gutter={24}>
          {items.map((formProps, index) => (
            <FormItem key={index} {...formProps} />
          ))}
        </Row>
        {bottomOptions.length > 0 && (
          <Form.Item>
            <div className={`flex flex-row justify-${bottomPosition} mt-6`}>
              {bottomOptions.map((item) => item)}
            </div>
          </Form.Item>
        )}
      </div>
    </Form>
  );
};

/**
 * @name FormGenerator.propTypes
 * @type { propTypes } React PropTypes.
 * @property { Array } items - FormItems array.
 * @property { Object } validateMessages - Form validation messages.
 * @property { Array } bottomOptions - Bottom options array.
 * @property { String } bottomPosition - Bottom options position - start, center or end.
 * @property { Function } onFinish - On submit function when is correct
 * @property { Function } onFinishFailed - On submit function when something is wrong
 * @property { Object } initialValues - Form initial values
 */
FormGenerator.propTypes = {
  items: PropTypes.array,
  validateMessages: PropTypes.object,
  bottomOptions: PropTypes.array,
  bottomPosition: PropTypes.string,
  onFinish: PropTypes.func,
  onFinishFailed: PropTypes.func,
  initialValues: PropTypes.object,
  optionsFirst: PropTypes.bool,
  requiredMark: PropTypes.bool,
  formParam: PropTypes.any
};

/**
 * Initialize default props
 */
FormGenerator.defaultProps = {
  items: [],
  validateMessages: {},
  bottomOptions: [],
  initialValues: {},
  bottomPosition: 'end',
  optionsFirst: false,
  requiredMark: true,
  formParam: false
};

export default FormGenerator;
